import React from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutDashboard, List, Clock, TestTube2, Flame, Menu } from 'lucide-react';

/**
 * The phone tab bar: five destinations plus the menu that holds everything else.
 *
 * Six equal columns rather than a flex row, so a long localised label cannot
 * push its neighbours around — each tab keeps its twelfth of the width and
 * ellipsises inside it.
 */
const BottomNav = React.memo(({ currentPage, setCurrentPage, onMenuClick, estimateCount = 0 }) => {
    const { t } = useTranslation();

    const navItems = [
        { page: 'dashboard', label: t('header.dashboard'), icon: <LayoutDashboard /> },
        { page: 'portfolio', label: t('header.portfolio'), icon: <List /> },
        { page: 'timeline', label: t('header.timeline'), icon: <Clock /> },
        { page: 'simulations', label: t('header.simulations'), icon: <TestTube2 /> },
        { page: 'fire', label: t('header.fire'), icon: <Flame /> },
    ];

    return (
        <nav className="tabbar">
            {/* `.tab.active svg { stroke: url(#tabGrad) }` needs a gradient to
                point at, and the demo injects one into the document. Without it
                the active tab's stroke resolved to nothing and its icon simply
                vanished — the one tab you always look at was the one with no
                glyph. userSpaceOnUse, not the default objectBoundingBox: a
                lucide path with no width or height of its own (a straight line
                in the hamburger) gets a zero-sized bounding box and is not
                painted at all, which is the demo's own note here. */}
            <svg width="0" height="0" aria-hidden="true" focusable="false" style={{ position: 'absolute' }}>
                <defs>
                    <linearGradient id="tabGrad" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="24" y2="24">
                        <stop offset="0%" stopColor="#00d4aa" />
                        <stop offset="100%" stopColor="#8b5cf6" />
                    </linearGradient>
                </defs>
            </svg>
            <div className="tabbar-inner">
                {navItems.map(item => {
                    const isCurrent = currentPage === item.page;
                    return (
                        <button
                            key={item.page}
                            onClick={() => setCurrentPage(item.page)}
                            className={`tab ${isCurrent ? 'active' : ''}`}
                            aria-current={isCurrent ? 'page' : undefined}
                        >
                            {item.icon}
                            <span>{item.label}</span>
                        </button>
                    );
                })}
                <button
                    onClick={onMenuClick}
                    className={`tab ${currentPage === 'settings' || currentPage === 'review' ? 'active' : ''}`}
                    aria-label={t('general.menu', 'Menu')}
                >
                    <Menu />
                    <span>{t('general.menu', 'Menu')}</span>
                    {/* F28.1 — the review page's count lives inside this menu, so
                        without a mark here the signal is unreachable on a phone. */}
                    {estimateCount > 0 && <span className="tab-dot" />}
                </button>
            </div>
        </nav>
    );
});

export default BottomNav;
